import { Loading } from 'components/Loading';
import { ClientInfoContext } from 'contexts/ClientInfoContext';
import { FeatureContext } from 'contexts/FeaturesContext';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { api } from 'services/api';
export const Auth = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { fetchDataAgency, setIdImob } = useContext(FeatureContext);
  const { setClearDataClientInfo } = useContext(ClientInfoContext);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tokenAccount = searchParams.get('accountToken');

  const history = useHistory();

  const fetchDataSignInToken = async (token: string) => {
    const authorization = token;
    setIsLoading(true);
    await setClearDataClientInfo();

    try {
      const { data } = await api.post(
        `login/account`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization,
          },
        },
      );
      return data;
    } catch (error: any) {
      history.push('/');
    } finally {
      setIsLoading(false);
    }
  };

  // Ver dependencia do useEffect

  async function loginAccount(data: any): Promise<void> {
    try {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('idToken');
      localStorage.removeItem('refreshToken');
      sessionStorage.clear();
      data = await fetchDataSignInToken(data);
      setIdImob(data.data.user.company_id);
      fetchDataAgency(data.data.token.accessToken, data.data.token.idToken);
      await localStorage.setItem('accessToken', data.data.token.accessToken);
      await localStorage.setItem('idToken', data.data.token.idToken);
      await localStorage.setItem('refreshToken', data.data.token.refreshToken);
      localStorage.setItem('name', data.data.user.name);
      localStorage.setItem('profile', data.data.user.profile);
      localStorage.setItem('picture', data.data.user.picture);
      localStorage.setItem('useImobId', data.data.user.user_imob_id);
      localStorage.setItem('company_id', data.data.user.company_id);
      fetchDataAgency(data.data.token.accessToken, data.data.token.idToken);
      window.sessionStorage.setItem('userFreshDesk', JSON.stringify(data.data.user));

      history.push('/ClientArea');
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    loginAccount(tokenAccount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>{isLoading && <Loading />}</>;
};
